export const ANIMATION_RUN_TIME = 1000;
